import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { couleurs } from "../../theme/tokens";

interface propsInterface {
    children: React.ReactNode;
}

/**
 * Chrome minimal pour les pages qui appartiennent à la PLATEFORME, pas à
 * une ville en particulier (politique de confidentialité, support). Avant
 * ce composant, ces pages utilisaient `Sidebar` — pensé pour les pages
 * propres à une ville (Accueil, Mon profil…), qui exige toujours une
 * municipalité résolue. Sur `liencitoyen.com` (aucune ville associée à ce
 * domaine, par conception), cette exigence faisait échouer la résolution
 * de municipalité et renvoyait systématiquement vers la page de vente,
 * quelle que soit l'adresse demandée — /support et /politique-confidentialite
 * y étaient donc inutilisables. Voir App.tsx (PAGES_SANS_VILLE).
 *
 * Logo Lien Citoyen générique (pas celui d'une ville) : ces pages parlent
 * de toute la plateforme, pas d'une municipalité précise — même sur le
 * sous-domaine d'une ville.
 */
export default function PageStatique({ children }: propsInterface) {
    return (
        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <Box component="header" sx={{ py: 3, textAlign: "center" }}>
                <Link to="/">
                    <Box
                        component="img"
                        src="/images/logo-h-2.png"
                        alt="Lien Citoyen"
                        sx={{ height: "36px" }}
                    />
                </Link>
            </Box>

            <Container sx={{ flexGrow: 1, pb: 6 }}>{children}</Container>

            <Box component="footer" sx={{ py: 3, textAlign: "center" }}>
                <Typography variant="caption" sx={{ color: couleurs.GrisTexte }}>
                    © {new Date().getFullYear()} Studio Cognitif inc. —{" "}
                    <Link to="/support" style={{ color: couleurs.GrisTexte }}>Assistance</Link>
                    {" · "}
                    <Link to="/politique-confidentialite" style={{ color: couleurs.GrisTexte }}>
                        Politique de confidentialité
                    </Link>
                </Typography>
            </Box>
        </Box>
    );
}
